// src/hooks/useTranslate.ts
import { useCallback } from "react";
import { useD3Fetch } from "@/hook/useD3Fetch"; // 예시: d3Fetch를 제공하는 훅 경로

/**
 * useTranslate 훅
 * - d3Fetch.post("/google/translate", { text, targetLang })를 호출하는
 *   handleTranslate 함수를 내부에서 만들고, 컴포넌트에서 재사용할 수 있도록 반환한다.
 */
export function useTranslate() {
  const d3Fetch = useD3Fetch(); // d3Fetch가 useD3Fetch 훅을 통해 반환된다고 가정

  const handleTranslate = useCallback(
    async (text: string, targetLang: string): Promise<string> => {
      try {
        const { data, success } = await d3Fetch.post("/google/translate", {
          text,
          targetLang,
        });

        if (success) {
          // 데이터가 성공적으로 넘어오면 번역된 문자열 반환
          return data as string;
        }
        // 실패하면 원문(text) 그대로 반환
        return text;
      } catch (error) {
        console.error("번역 중 에러 발생:", error);
        return text;
      }
    },
    [d3Fetch]
  );

  return handleTranslate;
}
